(function () {
  'use strict';

  const THRESHOLD = 4000;

  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function getProducts() {
    try {
      const el = document.getElementById('nsb-products-json');
      if (!el) return [];
      const json = el.textContent.trim().replace(/,(\s*\])/g, '$1');
      return JSON.parse(json);
    } catch (e) {
      return [];
    }
  }

  function getBestNudgeProduct(remaining, cartHandles) {
    const products = getProducts();
    const available = products.filter(function (p) {
      return !cartHandles.some(function (h) { return p.url.includes(h); });
    });

    const bridges = available.filter(function (p) {
      return p.price >= remaining;
    }).sort(function (a, b) { return a.price - b.price; });

    if (bridges.length) return bridges[0];

    return available.sort(function (a, b) { return a.price - b.price; })[0] || null;
  }

  function getCartHandles() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).map(function (item) {
          return item.handle;
        });
      });
  }

  function updateNudge(remaining) {
    getCartHandles().then(function (handles) {
      const product = getBestNudgeProduct(remaining, handles);
      const nudge = document.getElementById('nsb-nudge');

      if (!product || remaining <= 0) {
        if (nudge) nudge.style.display = 'none';
        return;
      }

      if (nudge) {
        const nameEl = nudge.querySelector('.nsb__nudge-name');
        const priceEl = nudge.querySelector('.nsb__nudge-price');
        const btn = nudge.querySelector('.nsb__nudge-btn');
        const img = nudge.querySelector('.nsb__nudge-img img');

        if (nameEl) nameEl.textContent = product.title;
        if (priceEl) priceEl.textContent = money(product.price);
        if (btn) {
          btn.dataset.variantId = product.id;
          btn.dataset.productUrl = product.url;
          btn.disabled = false;
          btn.textContent = 'Add';
          btn.classList.remove('nsb__nudge-btn--added');
        }
        if (img && product.image) img.src = product.image;
        nudge.style.display = '';
      }
    });
  }

  function renderBar(cartTotal) {
    const bar = document.querySelector('.nsb');
    if (!bar) return;

    const remaining  = Math.max(0, THRESHOLD - cartTotal);
    const pct        = clamp(Math.round((cartTotal / THRESHOLD) * 100), 0, 100);
    const isUnlocked = cartTotal >= THRESHOLD;

    bar.classList.toggle('nsb--unlocked', isUnlocked);
    bar.dataset.cartTotal = cartTotal;

    const track = bar.querySelector('.nsb__track');
    if (track) track.setAttribute('aria-valuenow', pct);

    const fill = bar.querySelector('.nsb__fill');
    if (fill) fill.style.width = pct + '%';

    const icon = bar.querySelector('.nsb__icon');
    if (icon) icon.innerHTML = isUnlocked ? svgCheck() : svgTruck();

    const msg = bar.querySelector('.nsb__message-text');
    if (msg) {
      if (isUnlocked) {
        msg.classList.add('nsb__message-text--success');
        msg.innerHTML = 'Free shipping &mdash; included with your order.';
      } else {
        msg.classList.remove('nsb__message-text--success');
        msg.innerHTML = 'Spend <strong>' + money(remaining) + '</strong> more for free shipping';
      }
    }

    updateNudge(remaining);
  }

  function svgCheck() {
    return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2.5 8.5L6 12L13.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function svgTruck() {
    return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 5.5H10.5V12H1V5.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path d="M10.5 7.5H12.5L14.5 9.5V12H10.5V7.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1" stroke="currentColor" stroke-width="1.2"/><circle cx="12" cy="12.5" r="1" stroke="currentColor" stroke-width="1.2"/></svg>';
  }

  const _fetch = window.fetch;

  window.fetch = function (input, init) {
    return _fetch.apply(this, arguments).then(function (response) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';

      if (
        url.includes('/cart/add')    ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        response.clone().json().then(function () {
          _fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { renderBar(cart.total_price); })
            .catch(function () {});
        }).catch(function () {
          _fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { renderBar(cart.total_price); })
            .catch(function () {});
        });
      }

      return response;
    });
  };

  document.addEventListener('cart:updated', function (e) {
    const total = e.detail && e.detail.cart && e.detail.cart.total_price;
    if (typeof total === 'number') renderBar(total);
  });

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBar(cart.total_price); })
      .catch(function () {});
  });

  document.addEventListener('change', function (e) {
    if (
      e.target &&
      e.target.closest &&
      e.target.closest('cart-items, cart-drawer-items')
    ) {
      setTimeout(function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { renderBar(cart.total_price); })
          .catch(function () {});
      }, 400);
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.nsb__nudge-btn');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added';
      btn.classList.add('nsb__nudge-btn--added');

      var cartRoot = document.querySelector('cart-root');
      cartRoot.dataset.hasItems = 'true';

      return cartRoot.updateHtml().then(function () {
        theme.transitions.reload('cart-drawer');
      });
    })
    .then(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderBar(cart.total_price); });

      setTimeout(function () {
        const nudge = document.getElementById('nsb-nudge');
        if (nudge) {
          nudge.style.transition = 'opacity 0.3s ease';
          nudge.style.opacity = '0';
          setTimeout(function () { nudge.remove(); }, 320);
        }
      }, 800);
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  });

})();